import { Base } from "ui/Scripts/source/framework/base";
import { IPagePanel } from "../common/pagePanel";
import { CompanyMenuItem, ICompanyMenuItem } from "ui/Scripts/source/models/company/companyMenuItem";
import { ISavedListFilter, SavedListFilter } from "../common/savedListFilter";
import { ITaskPageData, TaskPageData } from "./taskPageData";
import { TaskPagePanel } from "./taskPagePanel";

export interface ITaskPage extends ITaskPageData {
    panels: IPagePanel[];
    companies: ICompanyMenuItem[];
    companyFilters: ISavedListFilter[];
    userFilters: ISavedListFilter[];
    showDocumentPreview: boolean;
}

export class TaskPage extends TaskPageData implements ITaskPage {
    panels: TaskPagePanel[];
    companies: CompanyMenuItem[];
    companyFilters: SavedListFilter[];
    userFilters: SavedListFilter[];
    showDocumentPreview: boolean;

    constructor();
    constructor(obj: ITaskPage);
    constructor(obj?: any) {
        super(obj);
        this.panels = Base.getTypedArray(obj ? obj.panels : null, TaskPagePanel);
        this.companies = Base.getTypedArray(obj ? obj.companies : null, CompanyMenuItem);
        this.companyFilters = Base.getTypedArray(obj ? obj.companyFilters : null, SavedListFilter);
        this.userFilters = Base.getTypedArray(obj ? obj.userFilters : null, SavedListFilter);
        this.showDocumentPreview = obj && obj.showDocumentPreview || false;
    }
}
